  <template>
    <v-app>
      <!-- Navigation Drawer -->
      <v-navigation-drawer v-model="drawer" app class="mt-5 custom-drawer">
        <v-list>
          <v-list-item
            v-for="item in menuItems"
            :key="item.title"
            @click="navigate(item.route)"
            
            :class="{'selected-item': selectedRoute === item.route, 'hover-item': selectedRoute !== item.route}"
          >
            <v-list-item-content>
              <v-list-item-title>
                <v-icon left>{{ item.icon }}</v-icon>
                {{ item.title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>

      <!-- App Bar with Toggle Button -->
      <v-app-bar app class="elevation-2">
        <h3 class="title ma-5">Welcome,  {{ userName }}</h3>
        <v-spacer />
        <v-btn @click="toggleDrawer" icon>
          <v-icon>mdi-menu</v-icon>
        </v-btn>
      </v-app-bar>

      <!-- Main Content -->
      <v-main>
        <component :is="clickedItem" />
        <router-view />
      </v-main>
    </v-app>
  </template>

  <script>
  import AlumniRegister from './Home.vue';
  import Messages from './Messages.vue';
  import Events from './Events.vue';
  import Settings from './Settings.vue';

  export default {
    components: {
      AlumniRegister,
      Messages,
      Events,
      Settings,
    },
    name: 'App',
    data() {
      return {
        drawer: true,
        clickedItem: AlumniRegister,
        selectedRoute: 1, // Track the selected route
        menuItems: [
          { title: 'Update Profile', route: 1, icon: 'mdi-account' },
          // { title: 'Messages', route: 2, icon: 'mdi-message' },
          // { title: 'Events', route: 3, icon: 'mdi-calendar' },
          // { title: 'Settings', route: 4, icon: 'mdi-cog' },
        ],
      };
    },
    created() {
    // Get the username from localStorage when the component is created
    const user = localStorage.getItem('user');
    let userObject = JSON.parse(user);

    if (userObject) {
      this.userName = userObject.personalInfo.email; // Set the username
    }
  },
    methods: {
      toggleDrawer() {
        this.drawer = !this.drawer;
      },
      navigate(route) {
    
        this.selectedRoute = route; // Update the selected route
        if (route === 1) this.clickedItem = AlumniRegister;
        else if (route === 2) this.clickedItem = Messages;
        else if (route === 3) this.clickedItem = Events;
        else if (route === 4) this.clickedItem = Settings;

      },
    },
  };
  </script>

  <style scoped>
  .custom-drawer {
    background: linear-gradient(to bottom, #3f51b5, #1976d2); /* Gradient background */
    color: white; /* Text color for the drawer */
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); /* Subtle shadow */
  }

  .selected-item {
    background-color: #1976d2; /* Highlight color */
    color: white; /* Text color for the selected item */
  }

  .hover-item:hover {
    background-color: rgba(0, 0, 0, 0.1); /* Light hover effect */
  }

  .v-list-item-title {
    font-weight: bold; /* Bold title for menu items */
  }

  .title {
    font-weight: 600;
    color: #1976d2; /* Color of the app bar title */
  }

  .v-btn {
    color: #1976d2; /* Color for the toggle button */
  }
  </style>
